import { AfterViewInit, Directive, ElementRef, HostBinding, OnDestroy } from "@angular/core";

@Directive({
    selector: "p-tabView",
})
export class TabviewArrowsStateDirective implements AfterViewInit, OnDestroy {
    @HostBinding("class.tabview-no-arrows") tabviewNoArrows = false;
    @HostBinding("class.tabview-hide-next-arrow") tabviewHideNextArrow = false;

    private navContent: HTMLElement | null = null;
    private readonly onScroll = () => this.updateState();
    private readonly onResize = () => this.updateState();

    constructor(private hostRef: ElementRef) {}

    ngAfterViewInit(): void {
        this.navContent = this.hostRef.nativeElement.querySelector(".p-tabview-nav-content");

        if (!this.navContent) {
            return;
        }

        this.navContent.addEventListener("scroll", this.onScroll, { passive: true });
        window.addEventListener("resize", this.onResize);
        setTimeout(() => this.updateState());
    }

    ngOnDestroy(): void {
        this.navContent?.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("resize", this.onResize);
    }

    private updateState(): void {
        if (!this.navContent) {
            this.tabviewNoArrows = false;
            this.tabviewHideNextArrow = false;
            return;
        }

        const maxScrollLeft = this.navContent.scrollWidth - this.navContent.clientWidth;
        this.tabviewNoArrows = maxScrollLeft <= 1;
        this.tabviewHideNextArrow = this.tabviewNoArrows || Math.ceil(this.navContent.scrollLeft) >= maxScrollLeft - 1;
    }
}